import { render, staticRenderFns } from "./GenderSelector.vue?vue&type=template&id=d4d2f184&scoped=true&"
import script from "./GenderSelector.vue?vue&type=script&lang=js&"
export * from "./GenderSelector.vue?vue&type=script&lang=js&"
import style0 from "./GenderSelector.vue?vue&type=style&index=0&id=d4d2f184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d2f184",
  null
  
)

export default component.exports